import { render } from "./MarketDetails.vue?vue&type=template&id=19c7b090"
import script from "./MarketDetails.vue?vue&type=script&lang=js"
export * from "./MarketDetails.vue?vue&type=script&lang=js"

import "./MarketDetails.vue?vue&type=style&index=0&id=19c7b090&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__